// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__Kpslj.styles_ocean-50__rfscm {
  color: #e6f2ff;
}

.styles_color__Kpslj.styles_ocean-100__ft23B {
  color: #e6f2ff;
}

.styles_color__Kpslj.styles_ocean-200__6BmrV {
  color: #b3daff;
}

.styles_color__Kpslj.styles_ocean-300__hYbna {
  color: #7abfff;
}

.styles_color__Kpslj.styles_ocean-400__asPmB {
  color: #2392fb;
}

.styles_color__Kpslj.styles_ocean-500__n35nK {
  color: #0074e0;
}

.styles_color__Kpslj.styles_ocean-600__oRvac {
  color: #043571;
}

.styles_color__Kpslj.styles_space-50__-ROl1 {
  color: #f0f0f0;
}

.styles_color__Kpslj.styles_space-100__bMDOC {
  color: #e3e3e3;
}

.styles_color__Kpslj.styles_space-200__HD5XH {
  color: #bfbfbf;
}

.styles_color__Kpslj.styles_space-300__yxd-U {
  color: gray;
}

.styles_color__Kpslj.styles_space-400__OhgWL {
  color: #616161;
}

.styles_color__Kpslj.styles_space-500__bkD\\+n {
  color: #283439;
}

.styles_color__Kpslj.styles_gray-50__UsEZG {
  color: #eff3f6;
}

.styles_color__Kpslj.styles_gray-100__5B9wV {
  color: #e6ecef;
}

.styles_color__Kpslj.styles_gray-200__Ly-9b {
  color: #cfd8de;
}

.styles_color__Kpslj.styles_gray-300__z8oOD {
  color: #a8b9c2;
}

.styles_color__Kpslj.styles_gray-400__036Ev {
  color: #7e98a5;
}

.styles_color__Kpslj.styles_gray-500__Kwr0K {
  color: #738f9c;
}

.styles_color__Kpslj.styles_green-50__6Sbm9 {
  color: #e3fdf6;
}

.styles_color__Kpslj.styles_green-100__WHcOJ {
  color: #c5f6ea;
}

.styles_color__Kpslj.styles_green-200__aw\\+KU {
  color: #69ddc2;
}

.styles_color__Kpslj.styles_green-300__J-ZXs {
  color: #45bfa3;
}

.styles_color__Kpslj.styles_green-400__BdxtC {
  color: #1cab8a;
}

.styles_color__Kpslj.styles_green-500__tkpES {
  color: #128268;
}

.styles_color__Kpslj.styles_red-50__C1vis {
  color: #fff0f3;
}

.styles_color__Kpslj.styles_red-100__NYPkj {
  color: #f9d2db;
}

.styles_color__Kpslj.styles_red-200__VswJe {
  color: #f8b4c4;
}

.styles_color__Kpslj.styles_red-300__bv7yD {
  color: #e85e81;
}

.styles_color__Kpslj.styles_red-400__W-lqs {
  color: #e23661;
}

.styles_color__Kpslj.styles_red-500__rZnRW {
  color: #b82348;
}

.styles_color__Kpslj.styles_yellow-50__XSE5R {
  color: #fffae6;
}

.styles_color__Kpslj.styles_yellow-100__zaQHK {
  color: #fff0b3;
}

.styles_color__Kpslj.styles_yellow-200__hW6VE {
  color: #ffe380;
}

.styles_color__Kpslj.styles_yellow-300__lgwoP {
  color: #ffcf57;
}

.styles_color__Kpslj.styles_yellow-400__5rBvx {
  color: #ffc60a;
}

.styles_color__Kpslj.styles_yellow-500__glYXG {
  color: #ffb700;
}

.styles_color__Kpslj.styles_orange-50__NqK9s {
  color: #fff2eb;
}

.styles_color__Kpslj.styles_orange-100__hRYfw {
  color: #ffe4d6;
}

.styles_color__Kpslj.styles_orange-200__mKur\\+ {
  color: #ffc69e;
}

.styles_color__Kpslj.styles_orange-300__Pzgjs {
  color: #ffa047;
}

.styles_color__Kpslj.styles_orange-400__EvVEt {
  color: #ff7b42;
}

.styles_color__Kpslj.styles_orange-500__f90nk {
  color: #ee4920;
}

.styles_color__Kpslj.styles_turquoise-50__xlw7z {
  color: transparent;
}

.styles_color__Kpslj.styles_turquoise-100__LydhR {
  color: #e6fcff;
}

.styles_color__Kpslj.styles_turquoise-200__coxIn {
  color: #b3f5ff;
}

.styles_color__Kpslj.styles_turquoise-300__N-1CU {
  color: #78e2f2;
}

.styles_color__Kpslj.styles_turquoise-400__TKnH9 {
  color: #00c7e6;
}

.styles_color__Kpslj.styles_turquoise-500__TpyXJ {
  color: transparent;
}

.styles_color__Kpslj.styles_turquoise-600__\\+Vtkp {
  color: transparent;
}

.styles_color__Kpslj.styles_violet-50__eGYO7 {
  color: #eae6ff;
}

.styles_color__Kpslj.styles_violet-100__uePIr {
  color: #d9d1ff;
}

.styles_color__Kpslj.styles_violet-200__oNY7d {
  color: #bfb3ff;
}

.styles_color__Kpslj.styles_violet-300__sgG-Y {
  color: #9d90ea;
}

.styles_color__Kpslj.styles_violet-400__Ccont {
  color: #8678d9;
}

.styles_color__Kpslj.styles_violet-500__ray\\+8 {
  color: #6f5ccc;
}

.styles_color__Kpslj.styles_snow-50__\\+bpGM {
  color: white;
}

.styles_color__Kpslj.styles_snow-100__WJ3XB {
  color: #f7f7f7;
}

.styles_color__Kpslj.styles_snow-200__k0eUB {
  color: #f0efef;
}

.styles_color__Kpslj.styles_snow-300__JplxH {
  color: #e6e6e6;
}

.styles_color__Kpslj.styles_snow-400__AsXjS {
  color: #e1e0e0;
}

.styles_color__Kpslj.styles_snow-500__w7nTD {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__xh6VV.styles_ocean__fubO5 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__xh6VV.styles_ocean-light__WhCro {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__xh6VV.styles_green__syktb {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__xh6VV.styles_green-light__XMQuZ {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__xh6VV.styles_red__l5Fyf {
  background-color: #e23661;
  color: white;
}

.styles_background-color__xh6VV.styles_red-light__fSKLX {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__xh6VV.styles_orange__y9uZQ {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__xh6VV.styles_orange-light__-XGdb {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__xh6VV.styles_space__vVzTc {
  background-color: #616161;
  color: white;
}

.styles_background-color__xh6VV.styles_space-light__n4T1v {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__xh6VV.styles_gray-light__a5RcJ {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__xh6VV.styles_violet__jdJiL {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__xh6VV.styles_violet-light__ycQK4 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__xh6VV.styles_yellow__bqe97 {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__xh6VV.styles_yellow-light__BJii4 {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
/* stylelint-disable-next-line max-line-length */
/* TODO: Having different line-heights causes some UI and spacing issues.
 * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.
*/
.styles_badge__IqFBY {
  font-weight: 600;
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
  align-items: center;
  background-color: #1cab8a;
  border: 2px solid #cfd8de;
  border-radius: 50%;
  color: white;
  display: flex;
  height: 28px;
  justify-content: center;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 28px;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/content/timeline/go-to-bottom-button/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography_old.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ACXA,gDAAA;AASA;;CAAA;AFZA;EEgDI,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;EFrDjB,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAgVJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme_old';\n\n.badge {\n    @include theme_old.typo-old(subtitle2);\n\n    align-items: center;\n    background-color: theme_old.color(green-400);\n    border: 2px solid theme_old.color(gray-200);\n    border-radius: theme_old.get-border-radius(rounded);\n    color: theme_old.color(snow-50);\n    display: flex;\n    height: 28px;\n    justify-content: center;\n    position: absolute;\n    right: -10px;\n    top: -10px;\n    width: 28px;\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n/* stylelint-disable-next-line max-line-length */\n$typography-font-family: 'Open Sans', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue';\n$typography-font-weights: (\n    light: 300,\n    normal: 400,\n    semi-bold: 600,\n    bold: 700\n);\n\n/* TODO: Having different line-heights causes some UI and spacing issues.\n * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.\n*/\n$typography-variants: (\n    h1: 60px semi-bold 1.36 -0.03em,\n    h2: 48px semi-bold 1.5 -0.025,\n    h3: 34px semi-bold 1.6 -0.02em,\n    h4: 24px semi-bold 1.7 -0.015em,\n    h5: 20px semi-bold 1.8 -0.0125em,\n    h6: 16px semi-bold 1.9 -0.01em,\n    subtitle1: 14px semi-bold 2 0.01em,\n    subtitle2: 12px semi-bold 2.15 0.02em,\n    subtitle3: 10px semi-bold 2.4 0.04em,\n    body1: 14px regular 2 0.01em,\n    body2: 12px regular 2.15 0.02em,\n    body3: 10px regular 2.4 0.04em,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing, $text-transform: null) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n    text-transform: $text-transform;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo-old($variant, $includeFontFamily: false) {\n    @if $includeFontFamily {\n        font-family: $typography-font-family;\n    }\n\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__Kpslj`,
	"ocean-50": `styles_ocean-50__rfscm`,
	"ocean-100": `styles_ocean-100__ft23B`,
	"ocean-200": `styles_ocean-200__6BmrV`,
	"ocean-300": `styles_ocean-300__hYbna`,
	"ocean-400": `styles_ocean-400__asPmB`,
	"ocean-500": `styles_ocean-500__n35nK`,
	"ocean-600": `styles_ocean-600__oRvac`,
	"space-50": `styles_space-50__-ROl1`,
	"space-100": `styles_space-100__bMDOC`,
	"space-200": `styles_space-200__HD5XH`,
	"space-300": `styles_space-300__yxd-U`,
	"space-400": `styles_space-400__OhgWL`,
	"space-500": `styles_space-500__bkD+n`,
	"gray-50": `styles_gray-50__UsEZG`,
	"gray-100": `styles_gray-100__5B9wV`,
	"gray-200": `styles_gray-200__Ly-9b`,
	"gray-300": `styles_gray-300__z8oOD`,
	"gray-400": `styles_gray-400__036Ev`,
	"gray-500": `styles_gray-500__Kwr0K`,
	"green-50": `styles_green-50__6Sbm9`,
	"green-100": `styles_green-100__WHcOJ`,
	"green-200": `styles_green-200__aw+KU`,
	"green-300": `styles_green-300__J-ZXs`,
	"green-400": `styles_green-400__BdxtC`,
	"green-500": `styles_green-500__tkpES`,
	"red-50": `styles_red-50__C1vis`,
	"red-100": `styles_red-100__NYPkj`,
	"red-200": `styles_red-200__VswJe`,
	"red-300": `styles_red-300__bv7yD`,
	"red-400": `styles_red-400__W-lqs`,
	"red-500": `styles_red-500__rZnRW`,
	"yellow-50": `styles_yellow-50__XSE5R`,
	"yellow-100": `styles_yellow-100__zaQHK`,
	"yellow-200": `styles_yellow-200__hW6VE`,
	"yellow-300": `styles_yellow-300__lgwoP`,
	"yellow-400": `styles_yellow-400__5rBvx`,
	"yellow-500": `styles_yellow-500__glYXG`,
	"orange-50": `styles_orange-50__NqK9s`,
	"orange-100": `styles_orange-100__hRYfw`,
	"orange-200": `styles_orange-200__mKur+`,
	"orange-300": `styles_orange-300__Pzgjs`,
	"orange-400": `styles_orange-400__EvVEt`,
	"orange-500": `styles_orange-500__f90nk`,
	"turquoise-50": `styles_turquoise-50__xlw7z`,
	"turquoise-100": `styles_turquoise-100__LydhR`,
	"turquoise-200": `styles_turquoise-200__coxIn`,
	"turquoise-300": `styles_turquoise-300__N-1CU`,
	"turquoise-400": `styles_turquoise-400__TKnH9`,
	"turquoise-500": `styles_turquoise-500__TpyXJ`,
	"turquoise-600": `styles_turquoise-600__+Vtkp`,
	"violet-50": `styles_violet-50__eGYO7`,
	"violet-100": `styles_violet-100__uePIr`,
	"violet-200": `styles_violet-200__oNY7d`,
	"violet-300": `styles_violet-300__sgG-Y`,
	"violet-400": `styles_violet-400__Ccont`,
	"violet-500": `styles_violet-500__ray+8`,
	"snow-50": `styles_snow-50__+bpGM`,
	"snow-100": `styles_snow-100__WJ3XB`,
	"snow-200": `styles_snow-200__k0eUB`,
	"snow-300": `styles_snow-300__JplxH`,
	"snow-400": `styles_snow-400__AsXjS`,
	"snow-500": `styles_snow-500__w7nTD`,
	"background-color": `styles_background-color__xh6VV`,
	"ocean": `styles_ocean__fubO5`,
	"ocean-light": `styles_ocean-light__WhCro`,
	"green": `styles_green__syktb`,
	"green-light": `styles_green-light__XMQuZ`,
	"red": `styles_red__l5Fyf`,
	"red-light": `styles_red-light__fSKLX`,
	"orange": `styles_orange__y9uZQ`,
	"orange-light": `styles_orange-light__-XGdb`,
	"space": `styles_space__vVzTc`,
	"space-light": `styles_space-light__n4T1v`,
	"gray-light": `styles_gray-light__a5RcJ`,
	"violet": `styles_violet__jdJiL`,
	"violet-light": `styles_violet-light__ycQK4`,
	"yellow": `styles_yellow__bqe97`,
	"yellow-light": `styles_yellow-light__BJii4`,
	"badge": `styles_badge__IqFBY`
};
export default ___CSS_LOADER_EXPORT___;
